var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnoFechamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24609 12.6129C8.24609 11.4367 8.24609 10.8492 8.61156 10.4837C8.97702 10.1183 9.5645 10.1183 10.7407 10.1183H18.2246C19.4008 10.1183 19.9883 10.1183 20.3537 10.4837C20.7192 10.8492 20.7192 11.4367 20.7192 12.6129C20.7192 12.9067 20.7192 13.0538 20.6282 13.1455C20.5365 13.2366 20.3887 13.2366 20.0956 13.2366H8.86975C8.57601 13.2366 8.42882 13.2366 8.33715 13.1455C8.24609 13.0538 8.24609 12.906 8.24609 12.6129ZM8.24609 18.2258C8.24609 19.402 8.24609 19.9895 8.61156 20.355C8.97702 20.7204 9.5645 20.7204 10.7407 20.7204H18.2246C19.4008 20.7204 19.9883 20.7204 20.3537 20.355C20.7192 19.9895 20.7192 19.402 20.7192 18.2258V15.1075C20.7192 14.8138 20.7192 14.6666 20.6282 14.5749C20.5365 14.4839 20.3887 14.4839 20.0956 14.4839H8.86975C8.57601 14.4839 8.42882 14.4839 8.33715 14.5749C8.24609 14.6666 8.24609 14.8144 8.24609 15.1075V18.2258Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3633 8.87097V10.7419M17.5998 8.87097V10.7419",
    stroke: "#6796CF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnoFechamento);
export default __webpack_public_path__ + "static/media/anoFechamento.5a899e9178d932ac559b21ad6995540f.svg";
export { ForwardRef as ReactComponent };